import { useState, useEffect } from 'react'
import { useRouter } from 'next/router'
import { captureException } from '@sentry/nextjs'

import accountAnalytics from '~/analytics/account/accountAnalytics'

import { setAuthType } from '~/auth/slices/recaptcha.slice'
import { useAppDispatch } from '~/redux/hooks'
import { useLoginWithGoogleMutation } from '~/auth/apis/auth.api'

import { ButtonClickTypes } from '~/analytics/account/accountEvents.types'

import appConfig from '~/config/app'

import { AuthTypes } from '../types/auth.types'
import { getRouterQueryFrom } from '../utils/auth.utils'

const useAuthenticateWithGoogle = (redirectBack?: boolean): { loading: boolean; handleLoginWithGoogle: () => void } => {
  const router = useRouter()
  const [loading, setLoading] = useState(false)
  const [handleAuthWithGoogle, { data, isLoading, isSuccess, error }] = useLoginWithGoogleMutation()
  const dispatch = useAppDispatch()

  const handleLoginWithGoogle = (): void => {
    const from = redirectBack ? router.asPath : getRouterQueryFrom(router)
    accountAnalytics.logButtonClick(ButtonClickTypes.AUTH_GOOGLE)
    dispatch(setAuthType(AuthTypes.GOOGLE))
    handleAuthWithGoogle({ from, isMobile: appConfig.isMobileApp })
    setLoading(true)
  }

  useEffect(() => {
    if (isSuccess && !isLoading && data?.type === 'success' && data?.redirectUrl) {
      router.replace(data.redirectUrl)
    }
  }, [data, router, isSuccess, isLoading])

  useEffect(() => {
    if (error) {
      setLoading(false)
      captureException(error, { tags: { feature: 'auth', action: 'google-login' } })
    }
  }, [error])

  return {
    loading,
    handleLoginWithGoogle,
  }
}

export default useAuthenticateWithGoogle
